import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Typography, Divider, Space, Tag } from "antd";
import { ReactQrCode } from "@devmehq/react-qr-code";
import Auth from "../../../api/auth";
import { enrollTotpFactor } from "../UserSlice";
import { InputItem } from "../../../components/forms/FormItems";
import { useIntl } from "react-intl";
import store from "../../../redux/store";
import { CopyOutlined } from "@ant-design/icons";

const EnrollTotpModal = (props) => {
  const { visible, hideModal, engagement } = props;
  const [secret, setSecret] = useState("");
  const [mfaError, setMfaError] = useState("");
  const [uri, setUri] = useState("");
  const [code, setCode] = useState("");
  const [form] = Form.useForm();
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { totpSecret, currentUser } = await Auth.generateTotpSecret();
        if (totpSecret && currentUser) {
          setSecret(totpSecret);
          setUri(totpSecret.generateQrCodeUrl(currentUser.email, "Dreams"));
        } else {
          console.error("Failed to receive either totpSecret or currentUser.");
        }
      } catch (error) {
        // Check for Firebase specific error code
        if (error.code === "auth/operation-not-allowed") {
          setMfaError("auth/TOTP-based-MFA-not-enabled");
        }
      }
    };

    if (visible) {
      fetchData().catch(console.error);
    }
  }, [visible]);

  const onValuesChange = (changed, values) => {
    setCode(values.code);
  };

  const onSubmit = async () => {
    await store.dispatch(enrollTotpFactor({ secret, code }));
    hideModal(false);
    form.resetFields();
  };

  const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: "app.twoFactor.scanQR",
      })}
      open={visible}
      onCancel={hideModal}
      footer={
        secret
          ? [
              <Button key="cancel" onClick={hideModal}>
                {intl.formatMessage({
                  id: "app.actions.cancel",
                })}
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={false}
                onClick={onSubmit}
                disabled={code.length !== 6}
              >
                {intl.formatMessage({
                  id: "app.actions.send",
                })}
              </Button>,
            ]
          : [
              <Button key="close" onClick={hideModal}>
                {intl.formatMessage({
                  id: "app.actions.close",
                })}
              </Button>,
            ]
      }
    >
      {secret ? (
        <Form {...layout} form={form} onValuesChange={onValuesChange}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {engagement && (
              <Typography.Paragraph
                type="danger"
                style={{ paddingBottom: "20px" }}
              >
                {intl.formatMessage({
                  id: "app.twoFactor.engagement",
                })}
              </Typography.Paragraph>
            )}

            <Typography.Paragraph style={{ paddingBottom: "20px" }}>
              {intl.formatMessage({
                id: "app.twoFactor.insruction1",
              })}
            </Typography.Paragraph>
            <Typography.Text>
              {intl.formatMessage({
                id: "app.twoFactor.insruction2",
              })}
            </Typography.Text>
            <div style={{ padding: "10px" }}>
              <ReactQrCode value={uri} />
            </div>
            <Typography.Text>
              {intl.formatMessage({
                id: "app.twoFactor.insruction3",
              })}
            </Typography.Text>
            <Space>
              <Button
                type="text"
                icon={<CopyOutlined />}
                size={"small"}
                onClick={() => {
                  navigator.clipboard.writeText(secret.secretKey);
                }}
              />
              <Typography.Text>{secret.secretKey}</Typography.Text>
            </Space>
            <Divider></Divider>
            <Typography.Text style={{ paddingBottom: "20px" }}>
              {intl.formatMessage({
                id: "app.twoFactor.enterAppCode",
              })}
            </Typography.Text>
            <InputItem
              style={{ width: "90px" }}
              name="code"
              category="user"
              required={true}
              hideLabel={true}
              placeholder={intl.formatMessage({
                id: "app.forms.user.code",
              })}
              onlyPositiveNumbers={true}
              size="large"
              inputStyle={{ borderColor: "#000000" }}
            />
          </div>
        </Form>
      ) : mfaError ? (
        <Typography.Text type="danger" style={{ paddingBottom: "20px" }}>
          {intl.formatMessage({
            id: `app.notifications.${mfaError}`,
          })}
        </Typography.Text>
      ) : null}
    </Modal>
  );
};
export default EnrollTotpModal;
